import { refreshSession } from './refresh-session';

/**
 * calls regular fetch inside, but refreshes token on token expiration and sends request again
 * @param {string|URL|Request} - Every url param accepted by ƒetch
 * @param {RequestInit} - Request options accepted by ƒetch
 */
export const $fetch = async (url, options) => {
  const res = await fetch(url, options);
  const failedToken = options?.headers?.['X-Auth-Token'];
  if (res.status !== 401 || !failedToken) return res;

  const token = await refreshSession(failedToken).catch(() => null);
  if (!token) return res;

  return fetch(url, { ...options, headers: { ...options.headers, 'X-Auth-Token': token } });
};
